const KEY_CODES = {
  COMMA_CODE: 188,
  ENTER_CODE: 13,
  BACKSPACE_CODE: 8,
};
export default KEY_CODES;
